export default "__VITE_ASSET__BQesfyoi__"